import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as dashboardActions from "src/redux/slices/dashboardSlice";
import TableV2 from "src/components/ui/TableV2";

interface LowStockCardProps {
  limit?: number;
  enabled?: boolean;
  canReorder?: boolean;
}

const LowStockCard: React.FC<LowStockCardProps> = ({
  limit = 5,
  enabled = true,
  canReorder = false,
}) => {
  const dispatch = useAppDispatch();
  const { tenantLowStockAlerts } = useAppSelector((state) => state.dashboard);

  useEffect(() => {
    if (!enabled) return;
    dispatch(dashboardActions.getTenantLowStockAlertsRequest({ limit }));
  }, [dispatch, enabled, limit]);

  if (!enabled) return null;

  const rows = tenantLowStockAlerts.data?.products || [];
  const columns = [
    {
      key: "productId",
      header: "Product ID",
      accessor: ({ row }: { row: any }) => (
        <span className="text-gray-600">{row.productId || "-"}</span>
      ),
    },
    {
      key: "name",
      header: "Product",
      accessor: ({ row }: { row: any }) => (
        <span className="font-medium text-gray-900">{row.name}</span>
      ),
    },
    { key: "stock", header: "Current Stock" },
    { key: "minStock", header: "Reorder Level" },
    {
      key: "action",
      header: "Action",
      accessor: () =>
        canReorder ? (
          <Link
            to="/app/purchase/list"
            className="rounded-md border border-primary-200 px-3 py-1 text-xs font-semibold text-primary-600 hover:border-primary-300"
          >
            Reorder
          </Link>
        ) : (
          <span className="text-xs text-gray-400">-</span>
        ),
    },
  ];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <h2 className="text-sm font-semibold text-gray-700">Low Stock Alerts</h2>
      <div className="mt-4">
        <TableV2 columns={columns} data={rows} />
      </div>
    </div>
  );
};

export default LowStockCard;
